/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Read_PathInputs */



/**
* | output |
* | --- |
* | "Reading project file from path..." |
*
* @param {Load_Project_File_Status_Read_PathInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_read_path = /** @type {((inputs?: Load_Project_File_Status_Read_PathInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Read_PathInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lecture du fichier projet depuis le chemin...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektdatei wird vom Pfad gelesen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lettura del file di progetto dal percorso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Чтение файла проекта из указанного пути...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Leyendo archivo de proyecto desde la ruta...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从路径读取项目文件...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パスからプロジェクト ファイルを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस पथ से प्रोजेक्ट फ़ाइल पढ़ी जा रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lendo o arquivo do projeto a partir do caminho...")
	return /** @type {LocalizedString} */ ("Reading project file from path...")
});